import axios from "axios";
import moment from "moment"

const ReadMasterAxios = async function (props = {}) {
  var gett = localStorage.getItem("isloggedIn");
  var customerNo = localStorage.getItem("customerNumber");
  var userId = localStorage.getItem("userId");
  var locales = localStorage.getItem("locales") === "en" ? "en-IN" : `pt-BR`

  let congData = JSON.stringify({
    customerNumber: +customerNo,
    userId: userId,
    customer_no: +customerNo,
    user_id: +userId,
    customerNo: +customerNo,
    searchTerm: props.searchTerm,
    mainUserId: props.mainUserId,
    ...props.readItems
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : `${process.env.REACT_APP_MASTER_API}/${props.url}`;
  // : `https://dev-commongateway.elixia.tech/${props.url}`;

  if (props.completeURL) {
    try {
      return new Promise((resolve, reject) => {
        var config = {
          method: "get",
          url: apiURL,
          headers: {
            Authorization: `${gett}`,
            "Content-Type": "application/json",
            "Accept-Language": locales,
            "Access-Control-Allow-Origin": "*"
          },
          data: congData,
          params: {
            customer_no: +customerNo,
            user_id: +userId,
            userId: +userId,
            customerNo: +customerNo,
            customerNumber: +customerNo,
            mainUserId: props.mainUserId,
          },
        };

        axios(config)
          .then(function (response) {
            // console.log(JSON.stringify(response.data));
            resolve(response);
          })
          .catch(function (error) {
            // console.log(error);
            reject(error);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  } else if (props.completeURLL) {
    try {
      return new Promise((resolve, reject) => {
        var config = {
          method: "get",
          url: props.completeURLL,
          headers: {
            Authorization: `${gett}`,
            "Content-Type": "application/json",
            "Accept-Language": locales,
            "Access-Control-Allow-Origin": "*"
          },
          data: congData,
          params: {
            customer_no: +customerNo,
            user_id: +userId,
            userId: +userId,
            customerNo: +customerNo,
            customerNumber: +customerNo,
            mainUserId: props.mainUserId,
            billingPartyId: props.billingPartyId,
          },
        };

        axios(config)
          .then(function (response) {
            // console.log(JSON.stringify(response.data));
            resolve(response);
          })
          .catch(function (error) {
            // console.log(error);
            reject(error);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  }else {
    try {
      return new Promise((reslove, reject) => {
        axios
          .get(apiURL, congData, {
            headers: {
              "content-type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales,
              "Access-Control-Allow-Origin": "*"
            },
          })
          .then((res) => {
            if (res.data.status === 200 && res.data.resultSet !== "" && res.data.resultSet) {
              const resultSet = res.data.resultSet.map(rs => {
                try {
                  if (rs.hasOwnProperty('createdOn')) {
                    const createdOn = moment(rs.createdOn).isValid() ? moment(rs.createdOn).format("DD-MM-YYYY | HH:mm") : "N/A"
                    rs.createdOn = createdOn
                  }
                  if (rs.hasOwnProperty('updatedOn')) {
                    const updatedOn = moment(rs.updatedOn).isValid() ? moment(rs.updatedOn).format("DD-MM-YYYY | HH:mm") : "N/A"
                    rs.updatedOn = updatedOn
                  }
                  rs.updatedBy = rs.updatedBy || "N/A"
                } catch (error) {
                  console.log("Date Format Error")
                }
                return rs;
              })
              res.data.resultSet = resultSet
              reslove(res);
            } else {
              if (res.data.permissions) {
                reslove(res);
              } else {
                reslove(res);
              }
            }
          })
          .catch((err) => {
            console.log('err in read', err);
            reject(err);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  }
};

export default ReadMasterAxios;
